import { render, staticRenderFns } from "./Videomonitor.vue?vue&type=template&id=65f49877&scoped=true&"
import script from "./Videomonitor.vue?vue&type=script&lang=js&"
export * from "./Videomonitor.vue?vue&type=script&lang=js&"
import style0 from "./Videomonitor.vue?vue&type=style&index=0&id=65f49877&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f49877",
  null
  
)

export default component.exports